import type { ProductUpdateCategory } from '@lib/sanity/types';

// The global element styles pin a font on every heading and span, so the site
// heading face is set as a utility, which outranks them. Weight and tracking
// match the article page titles.
export const SITE_HEADING_CLASS_NAME =
  'font-heading font-extrabold tracking-[-0.02em]';

export const PLANNED_PATTERN_CLASS_NAME =
  'bg-white bg-[repeating-linear-gradient(135deg,#0b1b2b_0_1.5px,transparent_1.5px_4.5px)] shadow-[inset_0_0_0_1px_#0b1b2b]';

// Spotlight's amber is too light to hold its shape on white without an edge.
export const CATEGORY_SWATCH_CLASS_NAMES: Record<
  ProductUpdateCategory,
  string
> = {
  newFeature: 'bg-primary-600',
  improvement: 'bg-success-600',
  spotlight: 'bg-warning-400 shadow-[inset_0_0_0_1px_#c98a12]',
  beta: 'bg-secondary-600',
  comingSoon: PLANNED_PATTERN_CLASS_NAME
};

export const PRIMARY_BUTTON_CLASS_NAME =
  'inline-flex h-12 items-center justify-center rounded-lg bg-primary-700 px-[22px] font-heading text-[15px] font-bold text-white no-underline hover:bg-primary-800 hover:text-white';

export const BETA_BUTTON_CLASS_NAME =
  'inline-flex h-12 items-center justify-center rounded-lg bg-secondary-600 px-[22px] font-heading text-[15px] font-bold text-white no-underline hover:bg-secondary-700 hover:text-white';

export const TEXT_LINK_CLASS_NAME =
  'font-heading text-[15px] font-bold text-primary-700 underline-offset-2 hover:underline';

export const FOCUS_RING_CLASS_NAME =
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-700';
